import { render } from "./DoorPad.vue?vue&type=template&id=80636fe2"
import script from "./DoorPad.vue?vue&type=script&lang=js"
export * from "./DoorPad.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__